import type { Json, ListQuery } from "../contracts";

// Serialise a ListQuery to a POST body (generic CRUD /search) ...
export function listQueryToBody(query: ListQuery): Json {
    const body: Record<string, Json> = {};
    if (query.domain) body.domain = query.domain as unknown as Json;
    if (query.order) body.order = query.order;
    if (query.limit != null) body.limit = query.limit;
    if (query.offset != null) body.offset = query.offset;
    if (query.groupby && query.groupby.length > 0) body.group_by = query.groupby;
    return body;
}

// ... or to a query string (presentation /records GET).
export function listQueryToSearchParams(query: ListQuery): string {
    const params = new URLSearchParams();
    if (query.limit != null) params.set("limit", String(query.limit));
    if (query.offset != null) params.set("offset", String(query.offset));
    if (query.order) params.set("order_by", query.order);
    if (query.search) params.set("search", query.search);
    if (query.domain) params.set("domain", JSON.stringify(query.domain));
    if (query.groupby && query.groupby.length > 0) params.set("groupby", JSON.stringify(query.groupby));
    const serialized = params.toString();
    return serialized ? `?${serialized}` : "";
}

// Convert a dotted model key to the URL form generic CRUD expects (res.user → res__user).
export function modelKeyToPath(modelKey: string): string {
    return modelKey.replace(/\./g, "__");
}
